import {merge} from 'lodash-es';
import {BaseOctopusConfig} from '../../../../base.octopus-config';
import {defaultApiURL} from '../../../../src/app/settings/mathia';

const overrideConfig = {
    configuration: {
        http: {
            apiUrl: defaultApiURL,
        }
    }
}

const activitySearchEngineConfig = { // Rendre mutualisable si d'autres instances utilisent le moteur de recherche d'activités
    map: {lesson_facets: "http"}
}

export const MathiaOctopusConfig = merge({}, BaseOctopusConfig, activitySearchEngineConfig, overrideConfig);